import React from "react";

import { Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

export const tooltipHeader =
  (label: string): React.FC =>
  () => (
    <MaterialTooltip title={label} isShow>
      <Typography noWrap>{label}</Typography>
    </MaterialTooltip>
  );
